import { render, staticRenderFns } from "./EventThankYou.vue?vue&type=template&id=5e024e47&scoped=true&"
import script from "./EventThankYou.vue?vue&type=script&lang=js&"
export * from "./EventThankYou.vue?vue&type=script&lang=js&"
import style0 from "./EventThankYou.vue?vue&type=style&index=0&id=5e024e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e024e47",
  null
  
)

export default component.exports